import styled from 'styled-components';
import PropTypes from 'prop-types';

const ContentTile = styled.div`
    position: relative;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
    height: ${props => props.height || '100%'};
    margin-bottom: 32px;
    margin-right: 5px;
    margin-left: 5px;
    /* padding-bottom: 5px; */
    overflow: visible;
    box-shadow: 0 1px 2px 0 rgba(127,127,127,0.4);
    padding: ${props => (props.padding || '0px')};

    @media print {
        page-break-inside: avoid;

        .react-bootstrap-table .order {
            display: none;
        }
    }
`;

ContentTile.propTypes = {
    padding: PropTypes.string
};

export default ContentTile;



// WEBPACK FOOTER //
// ./src/components/atoms/layout/ContentTile.js